import uniqBy from 'lodash/uniqBy'

import { createSelector } from 'APP/Redux/utils'
import type { RootState } from '../CreateStore'
import { selectHistoryState } from '../History/selectors'
import { getRandomSummary, mapToJourneyAppointment, mockCarePlan } from './helpers'

const selectIdParam = (_: RootState, episodeIds: string[]) => episodeIds

const selectEpisodesById = createSelector(
  [(state: RootState) => state.history.episodes, selectIdParam],
  (episodes, episodeIds) =>
    Object.keys(episodes)
      .map((id) => (episodeIds.includes(id) ? episodes[id] : null))
      .filter((x) => !!x)
)
const selectAppointmentState = (state: RootState) => state.history.appointments
const selectPractitionerState = (state: RootState) => state.history.practitioners

const selectAppointmentsByEpisodeIds = createSelector(
  [selectAppointmentState, selectPractitionerState, selectIdParam],
  (appointments, practitioners, episodeIds) => ({
    past: mapToJourneyAppointment({ list: appointments.past, episodeIds, practitioners }),
    upcoming: mapToJourneyAppointment({ list: appointments.upcoming, episodeIds, practitioners }),
  })
)

const selectCareTeamByEpisodeIds = createSelector(
  [selectAppointmentsByEpisodeIds],
  ({ past, upcoming }) => {
    return uniqBy(
      [...past, ...upcoming].map((appointment) => appointment.practitioner),
      'id'
    )
  }
)

const selectEpisodeIdsByJourneyId = createSelector(
  [selectHistoryState, (_, journeyId) => journeyId],
  (_state, journeyId) => {
    // const journey = selectJourneyById(state, journeyId)
    // return journey.enpisodes.map((episode: Episode) => episode.id)
    // HACK: Until we have journeys, we use journeyId as if it was the array of episodeIds
    return [journeyId] as string[]
  }
)

export const selectJourneyData = createSelector(
  [(state: RootState) => state, (_, journeyId) => journeyId],
  (state, journeyId) => {
    const episodeIds = selectEpisodeIdsByJourneyId(state, journeyId)
    const episodes = selectEpisodesById(state, episodeIds)
    // using the first episode as placeholder until we know how to
    // derive journey data from episodes in a journey
    const episode = episodes[0]
    const { healthIssueTypeId, createdAt, channelId } = episode || {}

    return {
      appointments: selectAppointmentsByEpisodeIds(state, episodeIds),
      careTeam: selectCareTeamByEpisodeIds(state, episodeIds),
      // documents: selectDocumentsByEpisodeIds(state, episodeIds),
      carePlan: mockCarePlan,
      journey: { summary: getRandomSummary(), healthIssueTypeId, createdAt, channelId },
    }
  }
)
